import { ComponentProps } from 'src/lib/ComponentProps';

import { VideoItem } from '../_VideoPlayer/VideoItem';
import VideoPlayer from '../_VideoPlayer/VideoPlayer';

type VideoComponentProps = ComponentProps & VideoItem;

export default function Video(props: VideoComponentProps): JSX.Element {
	return <VideoPlayer video={props} />;
}
